import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { languages, useLocale, BASE_PATH } from "../../lang/languages";

import "./Footer.css";
import "./footer-signal.css";

/* Footer — design "Signal" 4a */
const Footer = () => {
  const { t } = useTranslation();
  const { locale } = useLocale();

  const switchTo = (target) => {
    if (locale === target) return;
    window.location.href = window.location.pathname.replace(
      new RegExp(`^\\/${locale}`),
      `/${target}`
    );
  };

  return (
    <footer className="ds-footer">
      <div className="ds-footer__inner">
        <div className="ds-footer__top">
          <span className="brand-logo ds-footer__logo">
            <span className="b-2fa">2FA</span>
            <span className="b-sms">SMS</span>
          </span>
          <span className="ds-footer__langs">
            {languages.map((l) => (
              <button
                key={l.locale}
                className={`ds-footer__lang ${
                  locale === l.locale ? "is-active" : ""
                }`}
                onClick={() => switchTo(l.locale)}
              >
                {l.locale.toUpperCase()}
              </button>
            ))}
          </span>
        </div>
        <div className="ds-footer__sep" />
        {/* Pages SEO (front-next) — même domaine en prod, REACT_APP_SEO_BASE en dev */}
        <div className="ds-footer__links">
          {(() => {
            const seo = process.env.REACT_APP_SEO_BASE || "";
            const links = [
              ["/receive-sms/whatsapp", t("footer.whatsapp")],
              ["/receive-sms/telegram", t("footer.telegram")],
              ["/receive-sms/google", t("footer.google")],
              ["/countries/usa", t("footer.usa")],
              ["/countries/united-kingdom", t("footer.uk")],
              ["/receive-sms", t("footer.all-services")],
              ["/countries", t("footer.all-countries")],
            ];
            return links.map(([path, label]) => (
              <a key={path} href={`${seo}/${locale}${path}`}>{label}</a>
            ));
          })()}
        </div>
        <div className="ds-footer__sep" />
        <div className="ds-footer__links">
          <Link to={`/free-numbers`}>{t("overview.freenum")}</Link>
          <Link to={`/privacy-policy`}>{t("overview.privacypolicy")}</Link>
          <Link to={`/terms-use`}>{t("overview.terms-use")}</Link>
          <Link to={`/payment-policy`}>{t("overview.payment-policy")}</Link>
          <Link to={`/return-policy`}>{t("overview.return-policy")}</Link>
          <Link to={`/help`}>{t("overview.faq-1")}</Link>
        </div>
        <span className="ds-footer__copy">
          © 2FASMS. {t("footer.rights")} · {new Date().getFullYear()}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
